import { render, staticRenderFns } from "./send-random.vue?vue&type=template&id=3137d2bc&"
import script from "./send-random.vue?vue&type=script&lang=js&"
export * from "./send-random.vue?vue&type=script&lang=js&"
import style0 from "./send-random.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports